module.exports = __webpack_public_path__ + "static/media/about_04.c41e8151.png";